// Time shorthands which can help with readability.
const ONE_SECOND = 1000;
const ONE_MINUTE = 60 * 1000;
const ONE_HOUR = 60 * ONE_MINUTE;
const ONE_DAY = 24 * ONE_HOUR;
const ONE_YEAR = 365 * ONE_DAY;
// Intentionally using en-US because we are not attempting to localize at this
// time.
const DATE_TIME_LOCALE = 'en-US';

export { DATE_TIME_LOCALE, ONE_DAY, ONE_HOUR, ONE_MINUTE, ONE_SECOND, ONE_YEAR };
//# sourceMappingURL=constants.js.map
